import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ScheduleAssignmentStatistics } from '../../models/action-team.models';

@Component({
  selector: 'md-schedule-statistics',
  templateUrl: './schedule-statistics.component.html',
  styleUrls: ['./schedule-statistics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleStatisticsComponent implements OnInit {
  // @ts-expect-error
  @Input() statistics: ScheduleAssignmentStatistics;

  constructor() {}

  ngOnInit() {}

  pad(value: number): string {
    return ('0' + value).slice(-2);
  }
}
